import { getResponseState } from "cando-util";
import { isFormFieldHidden } from "$lib/utilities/isFormFieldHidden.js";

export const getFormResponseState = (sections, responses, question, sectionComplete) => {
	const responseState = getResponseState(sections, responses, question, sectionComplete);
	for (const section of sections) {
		for (const entry of section.questions) {
			if (!entry.questionId || !responseState[entry.questionId]) continue;
			responseState[entry.questionId].hideInForm = isFormFieldHidden(entry, responses);
		}
	}
	return responseState;
};
